module.exports = __webpack_public_path__ + "img/chat_g.4a2bc182.svg";